import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';

const useStyles = makeStyles(() => ({
    title: {
        fontSize: '18px',
        fontWeight: 600,
        color: '#374151',
        marginBottom: '4px',
    },
    count: {
        fontSize: '24px',
        fontWeight: 700,
        color: '#1f2937',
    },
}));

interface SectionHeaderProps {
    title: string;
    count: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ title, count }) => {
    const classes = useStyles();

    return (
        <Box mb={3}>
            <Typography className={classes.title}>{title}</Typography>
            <Typography className={classes.count}>{count}</Typography>
        </Box>
    );
};
